// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:960px){.jd-section__items[data-v-4253493b]{display:flex;flex-wrap:wrap}.jd-section__items .jd-section__item[data-v-4253493b]{width:50%;padding-right:1rem}.jd-section__items .jd-section__item.jd-section__item--sm[data-v-4253493b]:nth-child(2){margin-top:0}}", ""]);
// Exports
module.exports = exports;
